"use strict";
/*!
 *
 *  stickyer.ts
 *
 */
Object.defineProperty(exports, "__esModule", { value: true });
var default_1 = /** @class */ (function () {
    function default_1(option) {
        var _this = this;
        this.isHidden = false;
        this.stateTop = 0;
        this.$wrapper = $('#wrapper');
        this.$menu = $('#megamenuBusiness');
        this.$a = this.$menu.prev('a');
        this.setting = {
            fixedElem: '#header',
            limitElem: undefined,
            elemClass: undefined,
            stateClass: '-hidden'
        };
        this.$local = $('#localFixed');
        this.hasLocal = $('#localFixed').length;
        this.$sns = $('.l_sns');
        this.borderline = 0;
        this.$solutionMenu = $('#solutionMenu');
        this.hasSolutionMenu = Boolean(this.$solutionMenu.length);
        this.solutionFixed = false;
        this.solutionTop = 0;
        this.$assistMenu = $('.l_assist_item.-menu');
        this.$assistMegamenu = $('.sol_megamenu');
        this.hasMegamenu = Boolean(this.$assistMenu.length);
        this.$solutionWidget = $('.sol_widget');
        this.hasSolutionWidget = Boolean(this.$solutionWidget.length);
        this.$footer = $('.l_footer');
        this.$page2top = $('#page2top');
        this.fixedPage2Top = true;
        this.chPos = 0;
        $.extend(true, this.setting, option ? option : {});
        this.$fixedElem = $(this.setting.fixedElem);
        this.stateClass = this.setting.stateClass;
        this.borderline = this.$fixedElem.height();
        $(window).on('scroll', function (e) {
            _this.scroll(e);
        });
        $(window).on('resize', function () {
            _this.borderline = _this.$fixedElem.height();
        });
        if (this.hasSolutionMenu) {
            this.megamenuPosition();
            this.solutionTop = this.$solutionMenu.offset().top;
            setTimeout(function () {
                _this.$solutionMenu.addClass('-anim');
            }, 100);
        }
        ;
        if (this.hasMegamenu) {
            if (util.isTouchDevice) {
                this.$assistMenu.children('a').on('click', function (e) {
                    var menu = $(e.currentTarget).data('menu');
                    if ($(menu).is(':hidden')) {
                        e.preventDefault();
                        $(e.currentTarget).parent('.l_assist_item').addClass('-show-menu');
                        $(menu).stop(false, true).animate({
                            height: 'show'
                        }, 500, 'easeOutQuart');
                    }
                    ;
                });
                $(document).on('click', function (e) {
                    if ($('.l_assist_item.-show-menu').length) {
                        if (!$(e.target).closest('.l_assist_item.-show-menu').length && !$(e.target).closest('.sol_megamenu').length) {
                            $('.sol_megamenu:visible').stop(false, true).animate({
                                height: 'hide'
                            }, 500, 'easeOutQuart');
                            $('.l_assist_item.-show-menu').removeClass('-show-menu');
                        }
                        ;
                    }
                    ;
                });
            }
            else {
                var onItem_1 = false;
                var onMegamenu_1 = false;
                this.$assistMenu.on('mouseenter', function (e) {
                    if (!onItem_1) {
                        onItem_1 = true;
                        var menu = $(e.currentTarget).children('a').data('menu');
                        $(e.currentTarget).addClass('-show-menu');
                        $('.sol_megamenu:visible').stop(false, true).animate({
                            height: 'hide'
                        }, 500, 'easeOutQuart');
                        $(menu).stop(false, true).animate({
                            height: 'show'
                        }, 500, 'easeOutQuart');
                    }
                    ;
                }).on('mouseleave', function (e) {
                    onItem_1 = false;
                    setTimeout(function () {
                        if (!onMegamenu_1 && !onItem_1) {
                            var menu = $(e.currentTarget).children('a').data('menu');
                            $(e.currentTarget).removeClass('-show-menu');
                            $(menu).stop(false, true).animate({
                                height: 'hide'
                            }, 500, 'easeOutQuart');
                        }
                        ;
                    }, 10);
                });
                this.$assistMegamenu.on('mouseenter', function (e) {
                    if (!onMegamenu_1) {
                        onMegamenu_1 = true;
                    }
                    ;
                }).on('mouseleave', function (e) {
                    if (onMegamenu_1) {
                        onMegamenu_1 = false;
                        setTimeout(function () {
                            if (!onMegamenu_1 && !onItem_1) {
                                $('.l_assist_item.-show-menu').removeClass('-show-menu');
                                $(e.currentTarget).stop(false, true).animate({
                                    height: 'hide'
                                }, 500, 'easeOutQuart');
                            }
                            ;
                        }, 10);
                    }
                    ;
                });
            }
            ;
        }
        ;
        $(window).on('viewportChanged', function () {
            if (_this.hasSolutionMenu) {
                if (_this.solutionFixed) {
                    _this.solutionFixed = false;
                    _this.$solutionMenu.removeClass('-fixed');
                }
                ;
                _this.megamenuPosition();
                _this.solutionTop = _this.$solutionMenu.offset().top;
                $(window).trigger('scroll');
            }
            ;
        });
        $(window).trigger('scroll');
        if (this.hasLocal) {
            this.$page2top.css({
                bottom: this.$local.outerHeight() + 10
            });
        }
        ;
    }
    default_1.prototype.scroll = function (e) {
        var top = $(e.currentTarget).scrollTop();
        top = top !== undefined ? top : 0;
        top = top < 0 ? 0 : top;
        var wh = this.$wrapper.height() - util.wh;
        top = top >= wh ? wh : top;
        var footerTop = this.$footer.offset().top;
        var pagetopBottom = this.$page2top.css('bottom') == 'auto' ? 0 : Number(this.$page2top.css('bottom').replace('px', ''));
        this.setCHPosition();
        if (this.fixedPage2Top && top + util.wh - pagetopBottom >= footerTop) {
            this.fixedPage2Top = false;
            this.$solutionWidget.removeClass('-show');
            this.$page2top.addClass('-static');
        }
        ;
        if (!this.fixedPage2Top && top + util.wh - pagetopBottom < footerTop) {
            this.fixedPage2Top = true;
            this.$solutionWidget.addClass('-show');
            this.$page2top.removeClass('-static');
        }
        ;
        if (!this.isHidden && top > this.stateTop && top > this.borderline && !this.$wrapper.is('.-overlay')) {
            this.isHidden = true;
            this.$fixedElem.addClass(this.stateClass);
            if (this.hasLocal) {
                this.$local.addClass(this.stateClass);
                this.$page2top.css({
                    bottom: 0
                });
            }
            ;
            // if (this.$wrapper.is('.-overlay')) {
            // 	this.$a.removeClass('-open');
            // 	this.$wrapper.removeClass('-overlay');
            // 	this.$menu.stop(false, true).animate({
            // 		height: 'hide'
            // 	}, 700, 'easeOutQuart');
            // };
            if (this.hasSolutionMenu) {
                this.$solutionMenu.addClass('-hidden-header');
            }
            ;
        }
        ;
        if (this.isHidden && (top < this.stateTop || top === 0)) {
            this.isHidden = false;
            this.$fixedElem.removeClass(this.stateClass);
            if (this.hasLocal) {
                this.$local.removeClass(this.stateClass);
                this.$page2top.css({
                    bottom: this.$local.outerHeight() + 10
                });
            }
            ;
            if (this.hasSolutionMenu) {
                this.$solutionMenu.removeClass('-hidden-header');
            }
            ;
        }
        ;
        var headerH = this.$fixedElem.height();
        if (this.isHidden) {
            headerH = 0;
        }
        ;
        if (!this.$page2top.is('.-visible') && top > this.chPos) {
            this.$page2top.addClass('-visible');
        }
        if (this.$page2top.is('.-visible') && top < this.chPos) {
            this.$page2top.removeClass('-visible');
        }
        if (this.hasSolutionMenu) {
            if (!this.solutionFixed && top + headerH >= this.solutionTop) {
                this.solutionFixed = true;
                this.$solutionMenu.addClass('-fixed');
                if (this.fixedPage2Top && this.hasSolutionWidget) {
                    this.$solutionWidget.addClass('-show');
                }
                ;
            }
            ;
            if (this.solutionFixed && top + headerH < this.solutionTop) {
                this.solutionFixed = false;
                this.$solutionMenu.removeClass('-fixed');
                if (this.fixedPage2Top && this.hasSolutionWidget) {
                    this.$solutionWidget.removeClass('-show');
                }
                ;
            }
            ;
            this.setCHPosition();
            this.megamenuPosition();
        }
        ;
        this.stateTop = top;
    };
    default_1.prototype.megamenuPosition = function () {
        var offset = this.$solutionMenu.offset().top;
        var scrollTop = $(window).scrollTop();
        var top = offset - scrollTop;
        var bottom = util.wh - (top + this.$solutionMenu.height());
        if (top > bottom && top > 500) {
            this.$assistMegamenu.addClass('-top');
        }
        else {
            this.$assistMegamenu.removeClass('-top');
        }
        ;
    };
    default_1.prototype.setCHPosition = function () {
        if ($('#topMainvis').length) {
            this.chPos = $('#topMainvis').offset().top + $('#topMainvis').height();
        }
        else {
            var _header = $('.common_header');
            if (_header.length <= 0) {
                _header = $('.pagetitilArea');
            }
            ;
            this.chPos = _header.offset().top + _header.height();
        }
        ;
    };
    return default_1;
}());
exports.default = default_1;
